import Modal from 'react-modal';
import api from '../../../../config';
import { toast } from 'react-toastify';
import { showMessageError } from '../../../../classes/functions';

export default function ModalReverseSeparation({reverseSeparation, customStyles, modalReverseSeparation, setModalReverseSeparation, setCarrying, id, setStatus}){
    function reverseSeparation() {
        setCarrying(true);
        api.get("/api/product_requests/setReverseSeparation?id=" + id)
        .then((response) => {
          setStatus(response.data.row.status);
          toast.success('Separação Estornada com Sucesso.');
          setModalReverseSeparation(false);
          setCarrying(false);
        }).catch((error) => {
          setCarrying(false);
          console.log(error);
          showMessageError(error.response.data);
        });
      }

    return (
        <Modal 
            isOpen={modalReverseSeparation} 
            onRequestClose={() => setModalReverseSeparation(false)} 
            style={customStyles} 
            contentLabel="Estornar Separação" 
            ariaHideApp={false}>
            
            <div className="body-modal">
            <div className="divGroup">
                <h3>Deseja realmente estornar a separação?</h3>
            </div>
            <div className="formDiv">
                <button type="button" className="buttonSubmit" onClick={reverseSeparation}>Confirmar</button>
                <button type="button" className="buttonCancel" onClick={() => setModalReverseSeparation(false)}>Fechar</button>
            </div>
            </div>
        </Modal>
    )
}